import React from 'react';
import { UserMemberShipContextMenu } from './UserMembershipContextMenu';
import { murmurhash } from '../../../../lib/js/hash';
import { UserMembership } from './UserMembership';
import { UserMembershipEdit } from '../UserMembershipTypes';
import { HeadingHierarchy } from '../../Heading/Heading';

export function UserMembershipEditable({
  status,
  roles,
  pageLink,
  hierarchy,
}: UserMembershipEdit & { hierarchy?: HeadingHierarchy }) {
  return (
    <UserMembership pageLink={pageLink} roles={roles} status={status} hierarchy={hierarchy}>
      {(role) => {
        return (
          <UserMemberShipContextMenu
            key={murmurhash(pageLink.name + role.name)}
            deleteForm={role.note ? role.deleteForm : undefined}
            editForm={role.editForm}
            role={role.name}
          />
        );
      }}
    </UserMembership>
  );
}
